import React, { Fragment } from "react";
import ClassNames from "classnames";
import { CARGO_DETAILS } from "Constants/commonConstants";

import { ReactComponent as SolidIcon } from "Icons/solid.svg";
import { ReactComponent as LiquidIcon } from "Icons/liquid.svg";
import { ReactComponent as PackedLiquidIcon } from "Icons/packed-liquid.svg";
import { ReactComponent as GasIcon } from "Icons/gas.svg";
import { ReactComponent as HazardousIcon } from "Icons/hazardous.svg";
import { ReactComponent as Others } from "Icons/others.svg";
import { ReactComponent as ForkLiftIcon } from "Icons/fork-lift.svg";

import { FlexWrapperT14 } from "Components/Common/Wrapper/FlexWrapper";
import { Spacer } from "Components/Common/Spacer/index";
import { LabelT6 } from "Components/Common/Label/index";

const CargoDetails = (props) => {
  const {
    cargoDetailsTypesList = [],
    cargo_details = [],
    handleToggleCargoDetails,
  } = props;

  const isSelected = (cargoEle) => {
    const C1 = cargo_details.some((ele) => {
      if (ele.id === cargoEle.value) {
        return true;
      } else {
        return false;
      }
    });

    if (C1) {
      return true;
    }

    return false;
  };
  return (
    <Fragment>
      <LabelT6>Cargo Details</LabelT6>
      <Spacer spacing={"3px"} />
      <FlexWrapperT14>
        {cargoDetailsTypesList.map((cargo, index) => {
          return (
            <div
              className={ClassNames(
                "border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10",
                {
                  // 'box-shadow select-icon border-theme br-5': this.cargoInfo.cargoDetails.indexOf(cargo.value) > -1
                  "box-shadow select-icon border-theme br-5": isSelected(cargo),
                }
              )}
              key={cargo.value}
              name={cargo.value}
              onClick={() => {
                handleToggleCargoDetails(cargo);
              }}
            >
              {cargo.value === 1 && <SolidIcon />}
              {cargo.value === 2 && <LiquidIcon />}
              {cargo.value === 3 && <PackedLiquidIcon />}
              {cargo.value === 4 && <GasIcon />}
              {cargo.value === 5 && <HazardousIcon />}
              {cargo.value === 6 && <SolidIcon />}
              {cargo.value === 7 && <ForkLiftIcon />}
              {cargo.value === 8 && <Others width={"35px"} height={"35px"} />}
              <div
                className={ClassNames("mt-10 fs-16 fBold tCenter", {
                  // 'theme-color ': this.cargoInfo.cargoDetails.indexOf(cargo.value) > -1,
                  // 'label-color ': !(this.cargoInfo.cargoDetails.indexOf(cargo.value) > -1)
                  "theme-color ": isSelected(cargo),
                  "label-color ": !isSelected(cargo),
                })}
              >
                {cargo.name}
              </div>
            </div>
          );
        })}
      </FlexWrapperT14>
    </Fragment>
  );
};

export default CargoDetails;
